import React from 'react'
import PlayerHistoryHomeNavigation from './PlayerHistoryHomeNavigation'
import './StatsAndStandingsHome.css'
import Footer from '../UIElements/Footer'
import SearchForPlayer from '../UIElements/SearchForPlayer'
import nsbhlLogo from '../../../images/nsbhl_no_background.png'

const PlayerStatsHome = () => {
	return (
		<div className='page-wrapper playerStatsHome'>
			<PlayerHistoryHomeNavigation />

			<main className='page-content playerStatsHome__content'>
				<div className='playerStatsHome__inner'>
					{/* <div className='playerStatsHome__icon'>♙</div> */}

					<h1 className='playerStatsHome__title'>FIND A PLAYER</h1>

					<div className='playerStatsHome__divider'>
						<span></span>

						<img
							src={nsbhlLogo}
							alt='NSBHL'
							className='playerStatsHome__dividerLogo'
						/>

						<span></span>
					</div>

					<p className='playerStatsHome__description'>
						Search for any player to view their history, teams, and career
						stats.
					</p>

					<div className='playerStatsHome__searchCard'>
						<div className='playerStatsHome__searchHeading'>
							<div className='playerStatsHome__searchIcon'>⌕</div>

							<div>
								<strong>To find a player's page,</strong>
								<span>start typing their last name:</span>
							</div>
						</div>

						<div className='playerStatsHome__search'>
							<SearchForPlayer />
						</div>
					</div>
				</div>
			</main>

			<Footer />
		</div>
	)
}

export default PlayerStatsHome
/* import React from 'react'
import PlayerHistoryHomeNavigation from './PlayerHistoryHomeNavigation'
import './StatsAndStandingsHome.css'
import Footer from '../UIElements/Footer'
import SearchForPlayer from '../UIElements/SearchForPlayer'

const PlayerStatsHome = () => {
	return (
		<div className='page-wrapper' style={{ overflowX: 'hidden' }}>
			<PlayerHistoryHomeNavigation />

			<main className='page-content'>
				<div style={{ marginTop: '6rem' }}>
					<div className='playerstatsnote'>
						<h4>To find a player's page, start typing their last name:</h4>
					</div>
					<SearchForPlayer />
				</div>
			</main>

			<Footer />
		</div>
	)
}

export default PlayerStatsHome
 */
